var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: "40px",
    height: "55px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.964 134.874s-32.08-10.062-51.344-16.002c-17.542-6.693-1.57-14.928 6.015-17.59 7.585-2.66 186.38-71.948 194.94-75.233 8.94-4.147 19.884-.35 14.767 18.656-4.416 20.407-30.166 142.874-33.827 158.812-3.66 15.937-18.447 6.844-18.447 6.844l-83.21-61.442z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.412 201.62s4.295.56 8.83-3.702c4.536-4.26 26.303-25.603 26.303-25.603",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.985 134.887l28.922 14.082-3.488 52.65s-4.928.843-6.25-3.613c-1.323-4.455-19.185-63.12-19.185-63.12z",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 16,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.985 134.887s127.637-77.45 120.09-71.138c-7.55 6.312-91.168 85.22-91.168 85.22z",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 9.67,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.1339c260f9ff0a6566b438244dd46383.svg";
export { ForwardRef as ReactComponent };